import { IS_LOCAL_API, LOCAL_SERVICE_PORTS, localApiHost } from './local-dev.js'

export const createServiceEndpoint = (service: string, env: string): string => {
  // Local-backend dev: route to the locally-running service on its own port.
  // A service the local stack does not run has no offset and falls through to
  // its cloud host.
  if (IS_LOCAL_API && LOCAL_SERVICE_PORTS[service] !== undefined) {
    return `http://${localApiHost()}:${LOCAL_SERVICE_PORTS[service]}`
  }
  return `https://${service}.api.${env}.droidmap.com`
}
